export enum DemandDefinitionStep {
    DEFINE_BASELINE = 'define-baseline',
    REVIEW_BASELINE = 'review-baseline',
    FORECAST_DEMAND = 'forecast-demand',
    FINALIZE_TENDER_DEMAND = 'finalize-tender-demand',
    REVIEW_AND_EXPORT = 'review-and-export',
}
